// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"206":"video-system","353":"contact","372":"coupon-mall","374":"zhixing","507":"join","594":"about","671":"services"}[chunkId] + "." + {"206":"f9d0b661","353":"7e6dcb46","372":"f800c550","374":"0b6c2bac","507":"1a921909","594":"bef89861","671":"0af9ac0d"}[chunkId] + ".css";
};